import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation, ContentChildren, forwardRef, QueryList, Input,
    OnInit } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

import { BaseDirective } from '../../../base.directive';
import { EuiListComponent } from '../eui-list.component';
import { EuiListService } from '../services/eui-list.service';
import { EuiIconComponent, EuiLabelComponent } from '../../atoms';

@Component({
    templateUrl: './eui-list-item.component.html',
    selector: '[euiListItem], eui-list-item',
    styleUrls: ['../styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiListItemComponent extends BaseDirective implements OnInit {

    @Input()
    get isCollapsible() { return this._isCollapsible; }
    set isCollapsible(value) { this._isCollapsible = coerceBooleanProperty(value); }
    _isCollapsible = false;

    @Input()
    get isCollapsed() { return this._isCollapsed; }
    set isCollapsed(value) { this._isCollapsed = coerceBooleanProperty(value); }
    _isCollapsed = true;

    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses('eui-list-item'),
        ].join(' ').trim();
    }

    @ContentChildren(forwardRef(() => EuiListComponent)) euiListComponent: QueryList<EuiListComponent>;
    @ContentChildren(forwardRef(() => EuiIconComponent)) euiIconComponent: QueryList<EuiIconComponent>;
    @ContentChildren(forwardRef(() => EuiLabelComponent)) euiLabelComponent: QueryList<EuiLabelComponent>;

    constructor(private euiListService: EuiListService) {
        super();
    }

    ngOnInit() {
        this.isCollapsible = this.euiListService.isCollapsible;
    }

    public toggleCollapse (event: Event) {
        if (this.isCollapsible) {
            this.isCollapsed = !this.isCollapsed;
        }
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.cancelBubble = true;
        }
    }
}
